import { SamplingPoint } from "./../types/samplingpoint.type";
import { Tmoa } from "./../types/tmoa.type";
import { Filter } from "./../types/filter.type";
import { responseHandlerDefault } from "@/utils/handler.util";
import axios from "./api";

export interface ClusterLabelRecord {
  utc_datetime: string;
  image_id: string;
  typology_name: string;
}

/**
 * get stations page
 *
 * @param page
 * @param size
 * @param filter
 * @returns
 */
export const getTmoa = (filter?: Filter): Promise<Tmoa[]> => {
  const params: { filter?: Filter } = {};

  if (filter) {
    params.filter = filter;
  }

  return axios.get(`/tmoa/`, { params }).then(responseHandlerDefault);
};

export const runScriptTmoa = (
  fromDate: Date,
  toDate: Date,
  samplingPoint: SamplingPoint
): Promise<void> => {
  const params: { from: string; to: string; point: number | undefined } = {
    from: (fromDate as Date).toString().replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, "$3-$2-$1"),
    to: (toDate as Date).toString().replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, "$3-$2-$1"),
    point: samplingPoint.id,
  };

  return axios.get(`/tmoa/script`, { params }).then(responseHandlerDefault);
};

export const updateTmoa = (
  id: number | undefined,
  name: string | undefined,
  value: number | undefined,
  file: string | undefined,
  color: string | undefined
): Promise<any> => {
  const body = {
    id: id,
    name: name,
    value: value,
    file: file,
    color: color,
  };

  return axios.post(`tmoa/updateTmoa`, body).then(responseHandlerDefault);
};

export const updateTmoaUser = (
  id: number | undefined,
  name: string | undefined,
  description: string | undefined
): Promise<any> => {
  const body = {
    id: id,
    name: name,
    description: description,
  };

  return axios.post(`tmoa/updateTmoaUser`, body).then(responseHandlerDefault);
};

export const uploadTmoaImage = async (station: string, file: File): Promise<any> => {
  const formData = new FormData();
  const fechaLocal = new Date().toISOString();

  formData.append("file", file);
  formData.append("dateLocal", fechaLocal);

  return axios.post(`tmoa/image/${station}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Elimina Tmoas por ids
export const deleteTmoas = (ids: number[]): Promise<any> => {
  return axios.post(`tmoa/deleteMany`, { ids }).then(responseHandlerDefault);
};

// Crea las Tmoas[] enviadas
export const createTmoas = (tmoas: any[]): Promise<any> => {
  return axios.post(`tmoa/createMany`, { tmoas }).then(responseHandlerDefault);
};

/**
 * Envía los resultados del clúster para el periodo de calibración.
 * * @param labels Array de registros etiquetados por el clúster
 * @returns Promise con la respuesta del servidor
 */
export const uploadClusterLabels = (labels: ClusterLabelRecord[], userId: number): Promise<any> => {
  const body = {
    userId: userId,
    labels: labels,
    source: "CLUSTER_CALIBRATION",
    timestamp: new Date().toISOString(),
  };

  return axios.post(`tmoa/uploadClusterLabels`, body).then(responseHandlerDefault);
};
